  /*============Vehicle Tagging Controller
  ================================*/
  angular
  .module('vppApp')
  .controller('vehicleTaggingController', vehicleTaggingController);

  vehicleTaggingController.$inject = ['$rootScope', '$scope', '$state', 'apiFactory', 'AuthenticationService', 'CustomerService', 'VehicleDetailService', 'ProgramInfoService'];

  function vehicleTaggingController($rootScope, $scope, $state, apiFactory, AuthenticationService, CustomerService, VehicleDetailService, ProgramInfoService){

    var convertToOptions = function (values) {
      var options = [];
      Object.keys(values).map(function(key) {
        options.push({
          label: values[key],
          value: key
        });
      });
      return options;
    };

    $scope.initFilters = function() {
      $scope.filtersLoading = true;
      apiFactory.vtInit(accountId, programId).then(function(response) {
        $scope.categoryOptions = convertToOptions(response.data.categories);
        $scope.yearOptions = convertToOptions(response.data.years);
        $scope.emissionCodeOptions = convertToOptions(response.data.titleStates);
        $scope.filtersLoading = false;
      }, function errorCallback(response) {
        $scope.serverError = response.data.errors;
        $scope.filtersLoading = false;
      });

    };

    $scope.resetDownstreamFilters = function(dropdown) {
      var element = $('select[data-dropdown="' + dropdown + '"]');
      while ((dropdown >= 4 || !element.val()) && element.length) {
        // stops execution when incremented data-dropdown attribute doesn't exist
        element = $('select[data-dropdown="' + (++dropdown) + '"]');
        if (element.length) {
          var model = element.attr('data-ng-model');
          model = model.replace('searchCriteria.', '');
          $scope.searchCriteria[model] = null;
        }
      }
    };

    $scope._updateFilters = function(dropdown){
      // triggered when user selects dropdown
      if (dropdown) {
        $scope.resetDownstreamFilters(dropdown);
      }

      // requires category, year, and state to be populated before submitting filters query
      if ($scope.vehicletagsearchform && $scope.vehicletagsearchform.$invalid) {
        return;
      }

      $scope.filtersLoading = true;
      var string = VehicleDetailService.toURLQuery($scope.searchCriteria);

      apiFactory.vtFilter(accountId, programId, string).then(function(response) {
        if (response.data.makes) { $scope.makeOptions = convertToOptions(response.data.makes); }
        if (response.data.models) { $scope.modelOptions = convertToOptions(response.data.models); }
        if (response.data.availabilities) { $scope.availabilityOptions = convertToOptions(response.data.availabilities); }
        if (response.data.colors) { $scope.colorOptions = convertToOptions(response.data.colors); }
        if (response.data.trims) { $scope.trimOptions = convertToOptions(response.data.trims); }
        if (response.data.locations) { $scope.locationOptions = convertToOptions(response.data.locations); }
        $scope.filtersLoading = false;
      }, function errorCallback(response) {
        $scope.serverError = response.data.errors;
        $scope.filtersLoading = false;
      });
    };

    $scope.submitTagSearch = function(){
      var string = VehicleDetailService.toURLQuery($scope.searchCriteria);
      $scope.searchLoaded = false;
      apiFactory.vtSearch(accountId, programId, string).then(function(response) {
        $scope.taggedVehicles = response.data.vehicles || [];
        $scope.loadedVehicles = $scope.taggedVehicles.slice(0, 6);
        $scope.searchLoaded = true;
        $scope.showResults = true;
      }, function errorCallback(response) {
        $scope.serverError = response.data.errors;
        $scope.searchLoaded = true;
      });
    };

    $scope.getVehicleSummary = function(){
      var emissionCode = $scope.searchCriteria.emissionCode;
      $scope.searchLoaded = false;
      apiFactory.vtSummary(accountId, programId, emissionCode).then(function(response){
        $scope.taggedVehicles = response.data.vehicles || [];
        $scope.loadedVehicles = $scope.taggedVehicles.slice(0, 6);
        $scope.searchLoaded = true;
      }, function errorCallback(response){
        $scope.serverError = response.data.errors;
        $scope.searchLoaded = true;
      });
    };

    $scope.loadMoreTags = function(){
      var length = $scope.loadedVehicles.length;
      $scope.loadedVehicles = $scope.taggedVehicles.slice(0, length + 6);
    };

    $scope.showAllTags = function(){
      $scope.loadedVehicles = $scope.taggedVehicles;
    };

    $scope.clickedOnVehicle = function(criteria){
      $scope.saveCriteria = true;
      $scope.searchCriteria = criteria;
    };

    $scope.goToVehicleDetail = function(vin){
      VehicleDetailService.destroyVehicleDetailVin();
      VehicleDetailService.setVehicleDetailVin(vin);
      VehicleDetailService.setSearchCriteria($scope.searchCriteria);
      $scope.customerPhone = CustomerService.getCustomerData().phone;
      $scope.searchLoaded = false;
      $scope.saveCriteria = true;
    };

    $scope.goOverview = function(){
      ProgramInfoService.addProgram(programPEP);
      $state.go('overview');
    };


    /**
     * Initialization code, execution basically starts here.
     * Needed to move $scope methods around so they would
     * be available when needed
    **/

    var accountId = AuthenticationService.getAuthenticatedID();
    var programId;
    var programPEP;
    $scope.searchLoaded = true;
    $scope.showResults = false;
    $scope.searchCriteria = {};
    $scope.taggedVehicles = [];
    $scope.loadedVehicles = [];
    $rootScope.hasPep = false;

    var onCustomerLoaded = function(customer) {
      if (customer) {
        accountId = AuthenticationService.getAuthenticatedID();
        var programIds = customer.programIDs;
        for(var i = 0; i < programIds.length; i++){
          if(programIds[i].code.toLowerCase() === 'vts'){
            programId = programIds[i].programID;
          }
          if (programIds[i].code.toLowerCase() === 'pep' || programIds[i].code.toLowerCase() === 'pepcont'){
            programPEP = programIds[i];
            $rootScope.hasPep = true;
          }

          if(programId && programPEP) break;
        }

        $scope.initFilters();

        // if coming from vin detail or state search
        if(['vehicle-tag-detail', 'available-vehicles'].indexOf($rootScope.fromState.name) >= 0) {
          $scope.searchCriteria = VehicleDetailService.getSearchCriteria();
          if (Object.keys($scope.searchCriteria).length) {
            $scope._updateFilters();
            $scope.submitTagSearch();
          }
        }
      }
    };

    CustomerService.addObserver(onCustomerLoaded);

    $scope.$on("$destroy", function() {
      CustomerService.removeObserver(onCustomerLoaded);

      // Handles whether state should be saved between navigation
      if ($scope.saveCriteria) {
        VehicleDetailService.setSearchCriteria($scope.searchCriteria);
      } else {
        VehicleDetailService.setSearchCriteria({});
      }
    });
  }